// filter Landmarks Which Have Name
export function filterLandmarksWhichHaveName(points = []) {
  const filtered = points.filter((point) => point.name);
  return filtered;
}

// get Categorized Points
export function getCategorizedPoints(points = []) {
  const categorized = points.reduce((acc, item) => {
    const type = item.type || "";
    if (!type) {
      return acc;
    }

    // append key as type for 1st time
    if (!acc[type]) {
      acc[type] = [];
    }

    // push the point
    acc[type].push(item);
    return acc;
  }, {});

  return categorized;
}

// calculate Distance
function calculateDistance(lat1, lng1, lat2, lng2) {
  const R = 6371; // Earth radius in KM

  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

// returns true if a point has a usable center with valid numeric lat/lng
function hasValidCenter(point) {
  const center = point && point.center;
  return (
    !!center &&
    typeof center.latitude === "number" &&
    typeof center.longitude === "number" &&
    !Number.isNaN(center.latitude) &&
    !Number.isNaN(center.longitude)
  );
}

// sort Points By Distance [nearest, ..., farthest]
export function sortPointsByDistance(points = [], latitude, longitude) {
  // do nothing if no points present
  if (points.length === 0) {
    return [];
  }

  const clonedPoints = [...points];
  const validPoints = clonedPoints.filter(hasValidCenter);
  const clonedValidPoints = [...validPoints];

  const sortedPoints = clonedValidPoints.sort((pointA, pointB) => {
    const { center: centerA } = pointA;
    const { center: centerB } = pointB;

    const distanceA = calculateDistance(
      latitude,
      longitude,
      centerA.latitude,
      centerA.longitude
    );

    const distanceB = calculateDistance(
      latitude,
      longitude,
      centerB.latitude,
      centerB.longitude
    );

    return distanceA - distanceB;
  });

  return sortedPoints;
}
